import { UrlLoadComponent } from '@trp-dms-digital-shared/ds-ui-library-components';

/**
 * Represents an orchestration for loading the url-load component.
 */
export class UrlLoadOrchestration {
  constructor() {
    this.loadUrlLoad();
  }

  protected createCallback(): void {
    // To be overridden by the child class
  }

  /**
   * Loads the url-load component by defining the custom element 'ds-url-load-component'.
   */
  public loadUrlLoad(): void {
    // Define the custom element for the url-load component
    if ('customElements' in window) {
      if (customElements.get('ds-url-load-component') === undefined) {
        // eslint-disable-next-line
        // @ts-ignore
        customElements.define('ds-url-load-component', UrlLoadComponent);
      }
    }
  }
}
